import { createAction } from 'reflux';

const selectYear = createAction();

export default selectYear;



/** WEBPACK FOOTER **
 ** ./app/scripts/actions/years.es6
 **/